/**
 * Dark/light theme — the professional "Split Roost" palette has both. Defaults
 * to light (matching kip-ai.be and the OS in most cases); `toggle()` flips it,
 * persists the choice, and App.svelte mirrors the flag onto `:root.dark`.
 */

const KEY = 'kip-theme';

function initialDark(): boolean {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'dark') return true;
    if (saved === 'light') return false;
  } catch {
    /* private mode / blocked storage — fall through to light */
  }
  return false;
}

class Theme {
  dark = $state<boolean>(initialDark());

  toggle(): void {
    this.dark = !this.dark;
    try {
      localStorage.setItem(KEY, this.dark ? 'dark' : 'light');
    } catch {
      /* best-effort */
    }
  }
}

export const theme = new Theme();
